export class scrollMenu {
    constructor () {
        var wrapper = document.getElementById('main-wrapper');
        window.addEventListener('scroll', function() {
            var position = wrapper.getBoundingClientRect();
            if ( position.top < -120 ) {
                document.body.classList.add('is-sticky');
            } else {
                document.body.classList.remove('is-sticky');
            }
        }, {
            capture: true
        });
    }
}